<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ organization.name }} - {{ $t("COMMON.SUBSCRIPTIONS") }}
    </h3>
    <subscription-list-table 
    :filterOrganization="organization.id" 
    @onViewSubscription="openSubscriptionViewModal"
    @onEditSubscription="openSubscriptionEditModal"
    />
  </div>
</template>

<script>
import SubscriptionListTable from "@/views/Pages/ResellerModule/SubscriptionManagement/partials/SubscriptionListTable.vue";
import {
  QUERY_ACTIONS_VIEW,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_ADD,
} from "@/constants/common";

export default {
  name: "organization-view-subscriptions",

  components: { SubscriptionListTable },

  props: ["organization"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {
    openSubscriptionViewModal(subscription, reRender = false) {
      if (reRender) {
        this.renderKey++;
      }

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List Subscriptions",
          query: {
            id: subscription.id,
            action: QUERY_ACTIONS_VIEW,
          },
        }).href
      );
      location.reload();
    },
    openSubscriptionEditModal(subscription, reRender = false) {
      if (reRender) {
        this.renderKey++;
      }

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List Subscriptions",
          query: {
            id: subscription.id,
            action: QUERY_ACTIONS_EDIT,
          },
        }).href
      );
      location.reload();
    },
  },

  mounted() {},

  watch: {
    organization(organization) {},
  },
};
</script>
